'use client';

import Link from 'next/link';
import { motion } from 'framer-motion';
import { useLocalePath } from '@/i18n/LangContext';

type Experience = {
  number: string;
  label: string;
  text: string;
};

// Ein einzelnes, ruhiges Erfahrungs-Band statt der früheren Vier-Karten-Stats.
export function StatsSection({ experience }: { experience: Experience }) {
  const lp = useLocalePath();

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 1.4 }}
      className="mb-16"
    >
      <Link
        href={lp('/work')}
        className="no-select flex flex-col sm:flex-row items-center gap-4 sm:gap-8 p-8 md:p-10 bg-[rgba(12,11,50,0.2)] backdrop-blur-sm rounded-xl border border-white/10 hover:border-[#88ffff]/40 transition-colors"
      >
        <div className="text-5xl md:text-6xl font-bold text-[#88ffff] whitespace-nowrap leading-none">
          {experience.number}
        </div>
        <div className="text-center sm:text-left">
          <div className="text-xl md:text-2xl font-semibold text-white mb-1">{experience.label}</div>
          <p className="text-white/70 leading-relaxed m-0">{experience.text}</p>
        </div>
      </Link>
    </motion.div>
  );
}
